import type { ItemUserModel } from '@wix/editor-elements-corvid-utils';
import type { CorvidTypes } from '@wix/editor-elements-types/corvid';
import { convertImagesToUserModel } from '@wix/thunderbolt-elements/components/TPAGallery/corvid/sdk-utils';
import type { GalleryItemProps, WixSDKItem } from '../ProGallery.types';

export const convertProGalleryItemsToUserModel = (
  items: Array<GalleryItemProps | WixSDKItem>,
  linkUtils: CorvidTypes.CorvidSDKApi['linkUtils'],
): Array<ItemUserModel> => {
  const images = items.map(item => {
    const image = (item as GalleryItemProps)?.image;
    return {
      id: (item as GalleryItemProps)?.dataId,
      type: 'Image',
      title: item.title,
      width: image?.width,
      height: image?.height,
      uri: image?.uri,
      alt: image?.alt,
      description: item.description,
      link: item.link,
    };
  });

  return convertImagesToUserModel(images, linkUtils);
};
